import { useState } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router'
import { useEffect } from 'react'
import { inject, observer, Provider } from 'mobx-react'
import posed, { PoseGroup } from 'react-pose'

import RetailStore from '../../models/RetailStore'

import RetailPayment from './retail-onboarding/payments/RetailPayment'

import RetailWelcome from './retail-onboarding/RetailWelcome'
import RetailReview from './retail-onboarding/RetailReview'
import { domain } from '../../api'
import BGRight from '../../assets/images/BGRight.svg'

function RetailDashboard() {
  const location = useLocation()

  const [retailStore] = useState(() => RetailStore.create({}))

  return (
    <Provider retailStore={retailStore}>
      <BackgroundWrapper>
        <PoseGroup animateOnMount>
          <RouteContainer key={location.key || location.pathname}>
            <Routes location={location}>
              <Route path='/welcome' element={<RetailWelcome />} />
              <Route path='/payment/*' element={<RetailPayment />} />
              <Route path='/review' element={<RetailReview />} />
              <Route path='/login' element={<RedirectToAzure />} />
              <Route path='/setup-account' element={<RedirectToAzureSignUp />} />
              <Route path='*' element={<RedirectToWelcome />} />
            </Routes>
          </RouteContainer>
        </PoseGroup>
      </BackgroundWrapper>
    </Provider>
  )
}

const RedirectToAzureSignUp = inject('store')(
  observer(props => {
    const {
      store: { selectPricebook },
    } = props

    useEffect(() => {
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)
      const pricebookId = urlParams.get('pricebookId')
      if (pricebookId) {
        const handlePricebookParam = async () => await selectPricebook(pricebookId)
        handlePricebookParam()
      }
      window.location.replace(`https://retail-auth.${domain}/oauth2/authorization/B2C_1_signup1`)
    }, [selectPricebook])

    return null
  })
)

function RedirectToAzure() {
  useEffect(() => {
    window.location.replace(`https://retail-auth.${domain}`)
  }, [])

  return null
}

function RedirectToWelcome() {
  const navigate = useNavigate()
  useEffect(() => {
    navigate('/retail/welcome', { replace: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}

const RouteContainer = posed.div({
  enter: { opacity: 1, delay: 300, beforeChildren: true },
  exit: { opacity: 0 },
})

const BackgroundWrapper = ({ children }) => {
  return <div style={{ background: `url(${BGRight}) no-repeat top right` }}>{children}</div>
}

export default inject('store')(observer(RetailDashboard))
